<div #VisualViewerContainer class="visual-viewer-container">
  <app-generic-toolbar
    [toolbarTitle]="visualization.title"
    [toolbarOptions]="toolbarOptions"
  ></app-generic-toolbar>
  <app-quicksight-visual-display
    [embedUrl]="visualization.embedUrl"
    [visualContentOptions]="visualContentOptions"
  ></app-quicksight-visual-display>
</div>
